var React = require('react');

function SubheroBg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M556.352 373.568C252.113 479.312 153.355 348.883 0 331.925V0H1440V471C1440 471 808.398 285.965 556.352 373.568Z"}));
}

SubheroBg.defaultProps = {"viewBox":"0 0 1440 471","fill":"none","preserveAspectRatio":"none"};

module.exports = SubheroBg;

SubheroBg.default = SubheroBg;
